import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const MessagePrioritizationRuleSettingsContainer = lazy(() =>
  import("@scenes/MessagePrioritization/components/MessagePrioritizationRuleSettings").then((module) => ({
    default: module.MessagePrioritizationRuleSettings,
  }))
);

export const appSettingsMessagePrioritizationRuleSettingsNRO: NavigationRoutingObject = {
  section: "settings",
  Component: MessagePrioritizationRuleSettingsContainer,
  heading: (t: I18nT<"dashboard-navigation">) =>
    t("app-settings-message-prioritization-rule-settings-nro-heading", "Prioritization Rules"),
  getDeveloperNavigationAllowed: ({ featureOn, hasPermissionForAnyScope }) => {
    const isMessagePrioritizationEnabled = featureOn("message_prioritization_m1");
    const isGranularPermissionsEnabled =
      featureOn("clip_granular_permissions_all") && featureOn("mx_granular_permission_campaigns_canvases");

    if (isGranularPermissionsEnabled) {
      return isMessagePrioritizationEnabled && hasPermissionForAnyScope("viewMessagePrioritization");
    }
    return isMessagePrioritizationEnabled && hasPermissionForAnyScope("basicReadOnly");
  },
  // NOTE: if you want to add an 'additionalSearchTerm', please use the scaffold
  // via 'yarn scaffold' > 'nros' > 'additionalSearchTerm' and follow the prompts
  additionalSearchTerms: () => [],
  // NOTE: when adding additionalSearchableFeatures make sure one of the
  // query params of the feature matches the key name of the feature.
  // NOTE 2: if you want to add an 'additionalSearchableFeature', please use the scaffold
  // via 'yarn scaffold' > 'nros' > 'additionalSearchableFeature' and follow the prompts
  additionalSearchableFeatures: () => ({}),
  noKnockoutFallback: true,
  componentFeatureFlippers: [],
};
